<div class="modal">
    <div class="header">
        <h1 class="title" translate>PREMIUM_ADMIN_MODAL_UPDATE_APP_TITLE</h1>
    </div>
    <div class="body">
        <div class="loading-container" *ngIf="(updateRunning$ | async)">
            <div class="loading-spinner-grey"></div>
        </div>
        <div class="section" *ngIf="!(updateRunning$ | async)">
            <div [innerHtml]="'PREMIUM_ADMIN_MODAL_UPDATE_APP_DESCRIPTION' | translate | safeHtml"></div>
        </div>
    </div>
    <div class="footer">
        <div class="button-wrapper">
            <button class="btn-new red" type="submit" (click)="onSubmit()" [disabled]="(updateRunning$ | async)"
                translate>PREMIUM_ADMIN_MODAL_UPDATE_APP_CONFIRM_BTN</button>
        </div>
    </div>
</div>